function linearGradient(color, colorState, angle = 85) {
    return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
  }
  
  export default linearGradient;